import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const LockerOpen: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M83.0421 159.03L106.729 154.779L75.6458 139.316L51.9893 143.581L83.0421 159.03Z"
      fill="url(#lockerOpen_paint0_linear)"
    />
    <path d="M147.719 17.9941L75.8448 30.9488L106.927 46.4117L178.802 33.4579L147.719 17.9941Z" fill="#C8C8C8" />
    <path d="M106.729 46.2134V154.779L75.6458 139.316V30.7505L106.729 46.2134Z" fill="#555555" />
    <path d="M107.143 46.8192V154.079L178.188 141.275V34.0134L107.143 46.8192Z" fill="#FBCE08" />
    <path d="M106.797 101.13L106.754 101.546L177.191 88.8496V88.4429L106.797 101.13Z" fill="#C39000" />
    <path d="M107.143 101.448V102.294L177.897 89.5279V88.6833L107.143 101.448Z" fill="#FCDE84" />
    <path d="M143.574 94.46V146.542L176.7 140.572V88.4412L143.574 94.46Z" fill="#393939" />
    <path d="M143.574 124.092L176.7 140.573L143.574 146.542V124.092Z" fill="#706D6D" />
    <path d="M143.576 118.495L147.408 120.406L171.533 116.067L157.801 109.215L143.55 111.779" fill="#FCDE84" />
    <path d="M143.38 142.97L147.405 142.172L143.503 140.23" fill="url(#paint1_linear_paint1_linear)" />
    <path d="M143.574 117.069L165.614 113.105L163.33 111.967L143.574 115.5V117.069Z" fill="#DBB569" />
    <path d="M143.547 118.471L147.405 120.397V142.166L143.556 140.246" fill="#C39000" />
    <path d="M147.404 120.397V142.166L171.53 137.827V116.057L147.404 120.397Z" fill="#FBCE08" />
    <path d="M154.471 129.393V137.584L168.557 135.044V126.855L154.471 129.393Z" fill="white" />
    <path
      d="M162.594 134.525C163.429 134.378 164.237 134.235 165.063 134.09V129.205C164.234 129.352 163.426 129.494 162.594 129.641V134.525ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="black"
    />
    <path
      d="M155.802 135.719C156.52 135.593 157.208 135.472 157.89 135.351V130.467C157.18 130.593 156.502 130.712 155.802 130.835V135.719ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="black"
    />
    <path
      d="M160.203 134.946C160.549 134.886 160.872 134.828 161.231 134.765V129.885C160.872 129.949 160.54 130.007 160.203 130.067V134.946ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="black"
    />
    <path
      d="M167.226 128.822C166.867 128.886 166.531 128.945 166.178 129.007V133.892C166.543 133.829 166.879 133.77 167.226 133.708V128.822ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="black"
    />
    <path
      d="M159.022 135.157C159.165 135.133 159.283 135.111 159.442 135.083V130.2C159.283 130.228 159.148 130.251 159.022 130.274V135.157ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="black"
    />
    <path
      d="M143.576 103.35L148.159 105.637L163.332 102.908L154.696 98.5987L143.576 100.599V103.35ZM51.9893 159.03H178.604V17.7959H51.9893V159.03ZM51.9893 17.7959H178.604V159.03H51.9893V17.7959Z"
      fill="#FCDE84"
    />
    <path d="M144.439 103.78L159.611 101.05L158.174 100.336L143.576 102.947V103.35L144.439 103.78Z" fill="#DBB569" />
    <path
      d="M143.515 103.319L148.158 105.637V119.327L143.547 117.036L143.515 103.319ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#C39000"
    />
    <path
      d="M148.159 105.637V119.328L163.332 116.599V102.908L148.159 105.637ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#FBCE08"
    />
    <path
      d="M152.604 111.295V116.447L161.461 114.849V109.699L152.604 111.295ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="white"
    />
    <path
      d="M157.712 114.523C158.237 114.431 158.745 114.341 159.264 114.249V111.177C158.744 111.269 158.234 111.359 157.712 111.451V114.523ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="black"
    />
    <path
      d="M153.439 115.274C153.891 115.194 154.324 115.119 154.753 115.043V111.971C154.306 112.049 153.88 112.125 153.439 112.203V115.274ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="black"
    />
    <path
      d="M156.207 114.788C156.424 114.75 156.628 114.714 156.854 114.674V111.605C156.628 111.645 156.419 111.682 156.207 111.72V114.788ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="black"
    />
    <path
      d="M160.624 110.937C160.398 110.977 160.187 111.014 159.965 111.053V114.126C160.195 114.085 160.405 114.048 160.624 114.009V110.937ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="black"
    />
    <path
      d="M155.465 114.921C155.555 114.905 155.63 114.893 155.73 114.874V111.802C155.63 111.82 155.545 111.835 155.465 111.849V114.921ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="black"
    />
    <path
      d="M106.796 126.953L106.753 127.368L143.371 120.741L143.414 120.326L106.796 126.953ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#C39000"
    />
    <path
      d="M106.993 127.306V128.151L142.93 121.674V120.828L106.993 127.306ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#FCDE84"
    />
    <path
      d="M142.923 53.2209V53.5934L178.189 47.2077V46.8351L142.923 53.2209ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#C39000"
    />
    <path
      d="M142.897 53.5942V54.4388L177.482 48.2027V47.3573L142.897 53.5942ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#FCDE84"
    />
    <path
      d="M106.797 88.0274L106.754 88.4429L177.191 75.747V75.3402L106.797 88.0274ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#C39000"
    />
    <path
      d="M106.936 88.3944V89.2398L177.986 76.4404V75.5958L106.936 88.3944ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#FCDE84"
    />
    <path
      d="M106.797 75.0051L106.754 75.4198L177.191 62.7247V62.3172L106.797 75.0051ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#C39000"
    />
    <path
      d="M107.097 75.3402V76.1848L177.986 63.4077V62.5631L107.097 75.3402ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#FCDE84"
    />
    <path
      d="M106.754 68.8359V69.2084L177.191 56.5133V56.1407L106.754 68.8359ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#C39000"
    />
    <path
      d="M107.143 69.124V69.9694L178.603 57.092V56.2474L107.143 69.124ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#FCDE84"
    />
    <path
      d="M106.729 153.186V153.585L178.603 140.631V140.232L106.729 153.186ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#8E8E8E"
    />
    <path
      d="M142.77 39.9184V148.232L143.579 148.085V39.7027L142.77 39.9184ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#FCDE84"
    />
    <path
      d="M178.603 33.9116L178.119 33.9991V33.3599L176.708 33.6393V34.2531L106.729 46.8662V50.0527L176.708 37.4404V141.725L178.119 141.454V37.1856L178.603 37.0989V33.9116ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#555555"
    />
    <path
      d="M111.99 59.894L115.632 59.2015L115.434 59.5016L111.991 60.1567L111.99 59.894ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M111.99 59.4069L116.003 58.6427L115.803 58.9428L111.991 59.6696L111.99 59.4069ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M111.991 60.3812L115.264 59.7587L115.066 60.0572L111.993 60.6423L111.991 60.3812ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M138.92 55.0287L135.292 55.7196L135.491 55.4187L138.918 54.766L138.92 55.0287ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M138.92 55.5151L134.924 56.2761L135.121 55.9776L138.919 55.254L138.92 55.5151ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M135.859 54.8607L138.918 54.278L138.918 54.5407L135.661 55.1616L135.859 54.8607ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M115.52 59.9713L117.244 57.3635C117.244 57.3635 119.16 56.9989 119.389 56.9551C119.626 56.9097 119.623 56.9981 119.507 57.1724C119.39 57.3499 119.19 57.6532 119.07 57.8331C119.009 57.9247 118.9 58.091 119.265 58.0218C119.649 57.9477 122.137 57.4741 122.137 57.4741C121.899 57.8371 121.125 58.9038 119.733 59.1689C118.606 59.3838 115.52 59.9713 115.52 59.9713ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M125.414 56.8492L124.479 58.2654L122.006 58.7358L122.942 57.3213L125.414 56.8492ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M128.99 56.1686L128.052 57.5832L125.582 58.0552L126.519 56.6391L128.99 56.1686ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M129.793 56.0166C129.793 56.0166 129.612 56.2912 129.525 56.4233C129.215 56.889 129.49 57.3109 130.503 57.1183C131.673 56.8962 134.471 56.3628 134.471 56.3628L135.407 54.9475L129.793 56.0166ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M116.722 56.0444L115.864 57.3436C115.864 57.3436 120.324 56.4942 120.553 56.4512C120.79 56.4058 120.787 56.4934 120.671 56.6677C120.554 56.8444 120.358 57.1517 120.238 57.3316C120.177 57.4224 120.068 57.5879 120.432 57.5187C120.817 57.4454 122.35 57.1533 122.35 57.1533C122.35 57.1533 122.657 56.686 122.917 56.296C123.268 55.7642 122.945 54.8599 121.684 55.0995C120.557 55.3145 116.722 56.0444 116.722 56.0444ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M129.2 55.8494L123.155 57.0005L124.805 54.5065L127.276 54.0352L126.33 55.4657L127.433 55.2556L128.379 53.8259L130.851 53.3546L129.2 55.8494ZM51.9893 159.031H178.603V17.7959H51.9893V159.031ZM51.9893 17.7959H178.603V159.031H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M134.272 52.7027L132.623 55.1975L130.004 55.6958L131.655 53.201L134.272 52.7027ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#D30511"
    />
    <path
      d="M177.191 140.485L108.14 152.932V49.1468L177.191 36.7009V140.485ZM106.729 46.2126V49.4V153.186V154.762V154.779L178.603 141.825V141.809V140.231V36.4461V33.2763V33.2588L106.729 46.2126ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#8E8E8E"
    />
    <path
      d="M143.195 43.4807V146.613L143.579 146.544V43.4042L143.195 43.4807ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#C39000"
    />
    <path
      d="M133.505 42.1935V43.7871L151.826 40.4677V38.874L133.505 42.1935ZM51.9893 159.03H178.603V17.7959H51.9893V159.03ZM51.9893 17.7959H178.603V159.03H51.9893V17.7959Z"
      fill="#555555"
    />
    <path d="M209.156 94.4617L209.157 95.608V146.544L176.549 140.573V88.4429L209.156 94.4617Z" fill="#FBCE08" />
    <path d="M209.152 94.4617V94.8589L176.546 88.8584V88.4429L209.152 94.4617Z" fill="#C39000" />
    <path d="M209.155 94.859V95.7036L176.549 89.7024V88.8594L209.155 94.859Z" fill="#FCDE84" />
    <defs>
      <linearGradient
        id="lockerOpen_paint0_linear"
        x1="60.9238"
        y1="151.958"
        x2="74.2865"
        y2="127.525"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.5" stopColor="#808080" stopOpacity="0.5" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="lockerOpen_paint1_linear"
        x1="125.669"
        y1="146.177"
        x2="147.151"
        y2="127.455"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.5" stopColor="#808080" stopOpacity="0.5" />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
